
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/proyectos",
      function () {
        return require("private-next-pages/proyectos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/proyectos"])
      });
    }
  